import React, { useContext, useEffect, useState } from "react";
import StateContext from "../../context/state";
import PathContext from "../../context/path";
import Main from '../Main';
import Popup from '../../components/Popup';
const Wrap = () => {
  const path = useContext(PathContext);
  const [isMobile, setMobile] = useState(false);
  const [answerIndex, setAnswerIndex] = useState([-1, -1, -1, -1]);
  const [popupOpen, setPopupOpen] = useState(false);
  const updatePopupOpen = (bool)=>setPopupOpen(bool);
  
  const updateAnswerIndex = (array)=>setAnswerIndex(array);
  useEffect(() => {
    const handleMobile = () => {
      if (window.innerWidth < 768 && !isMobile) {
        setMobile(true);
      }
      if (window.innerWidth > 767 && isMobile) {
        setMobile(false);
      }
    }
    handleMobile();
    window.addEventListener('resize', handleMobile);
    return () => {
      window.removeEventListener('resize', handleMobile);
    }
  }, [isMobile]);
  return (
    <>

      <StateContext.Provider value={{answerIndex: answerIndex, updateAnswerIndex: updateAnswerIndex, popupOpen: popupOpen,  updatePopupOpen: updatePopupOpen, isMobile: isMobile}}>
          <Popup />
          <Main />
      </StateContext.Provider>
    </>
  );

}

export default Wrap;
